import { Volume2 } from "lucide-react";
import { useStore } from "zustand";
import { Button } from "@/components/ui/button";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import { Slider } from "@/components/ui/slider";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { uiStore } from "@/lib/stores/ui-store";

type VolumeControlProps = {
	onPointerDown?: (e: React.PointerEvent) => void;
	container?: HTMLElement | null;
};

export function VolumeControl({
	onPointerDown,
	container,
}: VolumeControlProps) {
	const volume = useStore(uiStore, (state) => state.broadcastVolume);
	const setVolume = useStore(uiStore, (state) => state.setBroadcastVolume);

	return (
		<Popover>
			<TooltipProvider>
				<Tooltip>
					<TooltipTrigger asChild>
						<PopoverTrigger asChild>
							<Button
								onPointerDown={onPointerDown}
								size="icon"
								variant="secondary"
							>
								<Volume2 className="size-4" />
							</Button>
						</PopoverTrigger>
					</TooltipTrigger>
					<TooltipContent>Broadcast Volume</TooltipContent>
				</Tooltip>
			</TooltipProvider>
			<PopoverContent
				align="end"
				className="w-48"
				container={container}
				onPointerDown={onPointerDown}
			>
				<div className="space-y-2">
					<div className="flex items-center justify-between">
						<span className="font-medium text-sm">Volume</span>
						<span className="text-muted-foreground text-xs">
							{Math.round(volume * 100)}%
						</span>
					</div>
					<Slider
						max={1}
						min={0.3}
						onValueChange={([v]) => setVolume(v)}
						step={0.01}
						value={[volume]}
					/>
				</div>
			</PopoverContent>
		</Popover>
	);
}
